interface Options {
  allowMailTo: boolean;
}

export const prependProtocol = (
  value: string,
  options: Options = { allowMailTo: false },
) => {
  if (!value) return value;

  if (options.allowMailTo) {
    if (value.toLowerCase().startsWith("mailto:")) return value;
    if (value.includes("@")) return `mailto:${value.trim()}`;
  }

  if (/^https?:\/\/.*/i.test(value)) return value;

  return `https://${value.trim()}`;
};
